import { get } from 'store/http/httpAction';
import { ADD_OR_UPDATE_DATA, ADD_DATA, RESET_REPORTS } from './actionTypes';

export const addData = data => ({
  type: ADD_DATA,
  payload: { data }
});

export const resetReports = () => ({
  type: RESET_REPORTS,
});

export const tryFetchReportByIdIfNeeded = id => (dispatch, getState) => {
  // TODO: logic to avoid unnecessary fetch
  return get(`/admin/report/${id}`, {}, dispatch).then(data => {
    // Notes: the following code is just to avoid redundant re-render not fetch
    dispatch(addData(data.data));
  });
};

const addOrUpdateData = data => ({
  type: ADD_OR_UPDATE_DATA,
  payload: { data }
});

export const forceFetchReportById = id => dispatch =>
  get(`/admin/report/${id}`, {}, dispatch).then(data => {
    dispatch(addOrUpdateData(data.data));
  });



// WEBPACK FOOTER //
// ./src/store/metaData/reports/actions.js